import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { formatMoney } from "accounting";
import { language } from "../../utils/language";
import { getFreeShippingStatus } from "../../utils/shippingRules";
import { Banner, Strong } from "./styles";

type Props = {
  inContent?: boolean;
  wide?: boolean;
};

const FreeShippingMinBanner: React.FC<Props> = ({
  inContent = false,
  wide = false,
}) => {
  const homeState: HomeStateType = useSelector(
    (state: RootState) => state.home
  );
  const aveonlineIntegration: any = useSelector(
    (state: RootState) => state.aveonline.integration
  );
  const isAveonlineStore = Boolean(
    aveonlineIntegration?.status &&
      aveonlineIntegration?.wherehouseStatus === "Confirmado"
  );
  const status = getFreeShippingStatus(
    homeState.shippingType,
    homeState.freeShippingMinAmount,
    0
  );

  if (isAveonlineStore || !status.applies) return null;

  const lang = language[homeState.default_language];

  return (
    <Banner role="note" $inContent={inContent} $wide={wide}>
      <span>
        <Strong>{lang["freeShippingBannerStrong"]}</Strong>{" "}
        {lang["freeShippingBannerPrefix"]}{" "}
        <Strong>
          {formatMoney(status.minAmount, { symbol: "$", thousand: ",", precision: 0 })}{" "}
          COP,
        </Strong>{" "}
        {lang["freeShippingBannerSuffix"]}
      </span>
    </Banner>
  );
};

export default FreeShippingMinBanner;
